var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filtro-box',{attrs:{"header":"Debug","icono":"code-json"}},[(_vm.value)?_c('pre',{staticClass:"m-0 p-2 border-bottom"},[_vm._v(_vm._s(_vm.paramsFilters))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }